module.exports = __webpack_public_path__ + "static/media/faithtalk_logo.404085ba.png";